<script>
    export let row = null;
</script>

{row.role.name}/{row.name}